// extracted by mini-css-extract-plugin
export default {"payBillDetails":"paymentDetails_payBillDetails__qnAe8"};